import { Component, Mixins } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { AppFiltersMixin } from '@/mixins/AppFiltersMixin';
import { required } from 'vuelidate/lib/validators';
import { AppHypotheekMixin } from '../../mixins/AppHypotheekMixin';

@Component({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  validations: AppAflossenHypotheekdeelList.validations
})
export default class AppAflossenHypotheekdeelList extends Mixins(AppFiltersMixin, AppHypotheekMixin) {
  private static validations(this: AppAflossenHypotheekdeelList) {
    return {
      selectedHypotheekdeelnummer: {
        required
      }
    };
  }

  public selectedHypotheekdeelnummer = '';

  @Mutation('hypotheken/selectCurrentHypotheekdeelnummer')
  private selectCurrentHypotheekdeelnummer!: (hypotheekdeelnummer: string) => {};

  go() {
    if (this.hypotheek) {
      this.selectCurrentHypotheekdeelnummer(this.selectedHypotheekdeelnummer);
      this.$router.push({
        name: 'aflossen-hypotheekdeel',
        query: {
          from: 'list'
        }
      });
    }
  }
}
